import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { CssBaseline } from '@material-ui/core';
import {
  createMuiTheme,
  makeStyles,
  ThemeProvider,
} from '@material-ui/core/styles';
import moment from 'moment';
import Conteudo from './shared/layout/Conteudo';
import Notificacao from './features/notificacao';
import { chaveArmazenamentoUsuario } from './shared/util/Constantes';
import Router from './router';
import { atualizarUsuario } from './features/login/Store';
import store from './setup/reducer/index';

import Header from './features/header/views/Header';

import './App.css';
import styles from './theme';

const temaProjeto = createMuiTheme(styles);

const useStyles = makeStyles(() => ({
  '@global': styles.global,
}));

function App(props) {
  useStyles();
  const { estaAutenticado } = props;

  useEffect(() => {
    let usuarioArmazenado = JSON.parse(
      localStorage.getItem(chaveArmazenamentoUsuario)
    );
    if (
      !usuarioArmazenado ||
      !usuarioArmazenado.dataExpiracao ||
      !moment(usuarioArmazenado.dataExpiracao).isAfter(new Date())
    ) {
      localStorage.removeItem(chaveArmazenamentoUsuario);
      usuarioArmazenado = null;
    } else {
      setTimeout(() => {
        localStorage.removeItem(chaveArmazenamentoUsuario);
        store.dispatch(atualizarUsuario(null));
        document.location.reload(true);
      }, moment.duration(moment(usuarioArmazenado.dataExpiracao, 'YYYY/MM/DD HH:mm').diff(moment(new Date(), 'YYYY/MM/DD HH:mm'))).asSeconds() * 1000);
    }
    store.dispatch(atualizarUsuario(usuarioArmazenado));
  });

  return (
    <ThemeProvider theme={temaProjeto}>
      <CssBaseline />
      {estaAutenticado && <Header />}
      <Conteudo
        conteudo={
          <>
            <Router estaAutenticado={estaAutenticado} />
            <Notificacao />
          </>
        }
        estaAutenticado={estaAutenticado}
      />
    </ThemeProvider>
  );
}

const mapStateToProps = (state) => ({
  estaAutenticado: state.login.usuario != null,
});

export default connect(mapStateToProps)(App);
